import { RefusedArticle } from "@/interfaces/PartialReception";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

export const partialReceptionPersistConfig = {
  key: "partialReception",
  storage,
  whitelist: [
    "numTournee",
    "refusedArticles",
    "submittedRefusedIds",
    "blUrl",
    "isSubmitted",
  ],
};

export interface PartialReceptionState {
  numTournee: number | null;
  // Articles scannés donc refusés, le reste de la tournée est accepté
  refusedArticles: RefusedArticle[];
  // Refus déjà enregistrés côté serveur, sert à détecter une modification
  submittedRefusedIds: string[];
  // Vide quand tout est refusé ou tout accepté: aucun nouveau BL n'est édité
  blUrl: string;
  // Réception enregistrée côté serveur, il ne reste que le BL à joindre
  isSubmitted: boolean;
}

const initialState: PartialReceptionState = {
  numTournee: null,
  refusedArticles: [],
  submittedRefusedIds: [],
  blUrl: "",
  isSubmitted: false,
};

const partialReceptionSlice = createSlice({
  name: "partialReception",
  initialState,
  reducers: {
    startPartialReception(
      state,
      action: PayloadAction<{
        numTournee: number;
        refusedArticles: RefusedArticle[];
        blUrl: string;
        isSubmitted: boolean;
      }>
    ) {
      state.numTournee = action.payload.numTournee;
      state.refusedArticles = action.payload.refusedArticles;
      state.submittedRefusedIds = action.payload.refusedArticles.map(
        (refused) => refused.id
      );
      state.blUrl = action.payload.blUrl;
      state.isSubmitted = action.payload.isSubmitted;
    },
    refuseArticle(state, action: PayloadAction<RefusedArticle>) {
      state.refusedArticles.push(action.payload);
    },
    removeRefusedArticle(state, action: PayloadAction<string>) {
      state.refusedArticles = state.refusedArticles.filter(
        (refused) => refused.id !== action.payload
      );
    },
    savePartialReception(state, action: PayloadAction<string>) {
      state.blUrl = action.payload;
      state.submittedRefusedIds = state.refusedArticles.map(
        (refused) => refused.id
      );
      state.isSubmitted = true;
    },
    // Appelé une fois le BL cacheté joint: plus rien à conserver
    resetPartialReception() {
      return initialState;
    },
  },
});

export const {
  startPartialReception,
  refuseArticle,
  removeRefusedArticle,
  savePartialReception,
  resetPartialReception,
} = partialReceptionSlice.actions;
export default partialReceptionSlice.reducer;
